














import Vue from "vue";
import {Component} from "vue-property-decorator";
import {getModule} from "vuex-module-decorators"
import MetaModule from "@/store/meta.module"
import JdiMenu from "@/components/JdiMenu.vue"
import JdsTextProvider from "@/design-system/foundation/JdsTextProvider.vue"
import JdsTeleportProvider from "@/design-system/foundation/JdsTeleportProvider.vue"

const metaStore = getModule(MetaModule);

@Component({
    components: {JdsTeleportProvider, JdsTextProvider, JdiMenu}
})
export default class Docs extends Vue {

    console = console

    get version() {
        return metaStore.version;
    }
}
